import 'twin.macro';
import 'styled-components/macro';

import { Icon } from 'component-lib/atoms/icon/Icon';
import { Button } from 'play/atoms/button/Button';
import { Modal, ModalBody } from 'play/molecules/modal/Modal';
import { useTrackAmplitudeEvent } from 'support/amplitude/amplitudeEvent';

import { ReactComponent as InstruqtLogo } from './images/instruqt-branding-logo.svg';
import { ReactComponent as Share } from './images/share.svg';

export interface InstruqtBrandingModalProps {
  open: boolean;
  onClose: () => void;
}

export const InstruqtBrandingModal = ({ open, onClose }: InstruqtBrandingModalProps) => {
  const trackAmplitudeEvent = useTrackAmplitudeEvent();

  return (
    <Modal width="large" open={open} onClose={onClose}>
      <ModalBody tw="flex flex-col items-center p-5 relative gap-3">
        <Icon
          tw="text-3xl text-current absolute top-2 right-2 cursor-pointer"
          name="circle-remove"
          role="close"
          onClick={onClose}
        />
        <span>Powered by</span>
        <InstruqtLogo />
        <p tw="px-4 text-center">
          Instruqt is a full product growth suite. We empower companies to increase sales and adoption using their own
          product.
        </p>
        <a
          href="https://instruqt.com/solutions/employee-onboarding?utm_source=platform&utm_medium=logo"
          target="_blank"
          rel="noreferrer noopener"
          onClick={() => {
            trackAmplitudeEvent({
              name: 'Lab - Bradning Modal - View website',
            });
          }}
        >
          <Button variant="outline" tw="flex items-center">
            <Share tw="mr-1" />
            View website
          </Button>
        </a>
      </ModalBody>
    </Modal>
  );
};
